import { render } from "./TotalMensalCobrancaView.vue?vue&type=template&id=153e05b8&scoped=true"
import script from "./TotalMensalCobrancaView.vue?vue&type=script&lang=js"
export * from "./TotalMensalCobrancaView.vue?vue&type=script&lang=js"

import "./TotalMensalCobrancaView.vue?vue&type=style&index=0&id=153e05b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153e05b8"]])

export default __exports__